module.exports = __webpack_public_path__ + "img/Dailyworkselect.d8692c62.svg";